/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserClaimsDto } from '../models/UserClaimsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminUsersApiService {
    /**
     * Returns claims information about all available users
     * @returns UserClaimsDto OK
     * @throws ApiError
     */
    public static getUsersClaims(): CancelablePromise<Array<UserClaimsDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin-api/v1/users',
        });
    }
}
